/* Player vidéo dans un dom element.
- dans app.js modifier la config du jeu : 
        ...
        dom: {
            createContainer: true
        },
        ...
- dans le head de index.html charger le js et css de videoplayer :
        <link href="https://unpkg.com/video.js/dist/video-js.min.css" rel="stylesheet">
        <script src="https://unpkg.com/video.js/dist/video.min.js"></script>
- charger le fichier html dans le preloader : this.load.html('videoPlayer', 'assets/videos/domvideo.html');

*/
export default class DOMVideo extends Phaser.GameObjects.DOMElement{
    constructor(scene, x, y, pathFile, funcEndVideo) {
        super(scene, x, y)
        scene.add.existing(this);

        this.setOrigin(0)

        this.scene = scene;
        this.soundManager = scene.soundManager

        // Creation du player dnas le dom
        this.createFromCache('videoPlayer');

        // Modif du lien de la video
        var video = this.getChildByID("video");
        video.src = pathFile;
    
        var source = this.getChildByID("player-video");
        source.src = pathFile;

        this.addVideoJS(funcEndVideo);
    }

    addVideoJS(funcEndVideo){
        var player = videojs('player-video')
        player.ready(function (event) {
            player.on('play', ()=> {
                this.soundManager.pauseAudioFromVideo()
            })
            player.on('ended', function (event) {
                player.off('ended')

                this.videoComplete(player, funcEndVideo);
                player.currentTime(0);
                this.soundManager.resumeAudioFromVideo()

            }.bind(this));
        }.bind(this), {
            passive: false
        });
        
    }

    videoComplete(player, funcEndVideo) {
        funcEndVideo();
    }

    delete(){
        videojs('player-video').dispose();
        this.soundManager.resumeAudioFromVideo()
    }
}